import {Component} from '@angular/core';

@Component({
    selector: 'vui-data-grid-groups',
    templateUrl: './data-grid-groups.component.html',
    styleUrls: ['./data-grid-groups.component.scss']
})
export class DataGridGroupsComponent {
}
